module.exports = __webpack_public_path__ + "static/media/81 - Pierre Vassiliu - Qui c'est celui-là _.d60a7925.mp3";